import { initializeApp } from "firebase/app";
import { defineNuxtPlugin, useRuntimeConfig } from "#imports";
export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig();
  const firebaseApp = initializeApp(runtimeConfig.public.vuefire.config);
  return {
    provide: {
      firebaseApp
    }
  };
});
